import { PageState } from 'models/PageState';
import { isProductPage } from 'models/ProductPageModel';

export const getAccessories = ({ currentPage }: PageState) => {
  if (!isProductPage(currentPage)) {
    return [];
  }
  const { accessories } = currentPage;
  const hasAccessories =
    accessories && accessories.length > 0 && accessories.every(a => a.title !== undefined);
  return hasAccessories ? accessories : undefined;
};
